import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DocumentEncoding } from '../../distribution/models/document-encoding';
import { DistributionService } from '../../distribution/services/distribution.service';
import { DxLookupModule } from 'devextreme-angular';

import { EncodingPickerService } from './encoding-picker.service';

@Component({
    selector: 'app-encoding-picker',
    templateUrl: './encoding-picker.component.html',
    styleUrls: ['./encoding-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLookupModule]
})

export class EncodingPickerComponent implements OnInit, OnChanges  {
    distributionService = inject(DistributionService);
    encodingPickerService = inject(EncodingPickerService);
    encodingDataSource: DataSource;
    encodings: DocumentEncoding[] = [];
    loadingEncodings = false;
    isReadOnly = false;

    selectedEncoding: DocumentEncoding;
    @Input() assemblyTypes: string[] = null;
    @Input() selectedEncodingId: number;
    @Output() selectedEncodingIdChange: EventEmitter<number> = new EventEmitter<number>();

    ngOnInit(): void {
        void this.initAsync();
    }

    async initAsync(): Promise<void> {
        try {
            this.loadingEncodings = true;
            this.encodings = await this.distributionService.getDocumentEncodings();
            this.findSelectedEncoding();

            const store = new CustomStore({
                load: (loadOptions: any) => {
                    const data = this.encodings;
                    const v = loadOptions.searchValue;
                    if (!v) return data;
    
                    const search = String(v).toLocaleLowerCase();
                    return data.filter(e => {
                        const display = (e.DisplayName ?? '').toLocaleLowerCase();
                        const name = (e.Name ?? '').toLocaleLowerCase();
                        return display.includes(search) || name.includes(search);
                    });
                },
                byKey: (key: any) => key
            });
    
            this.encodingDataSource = new DataSource({
                store: store,
                paginate: false
            });
        }  
        finally{
            this.loadingEncodings = false;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedEncodingId && this.selectedEncodingId) {
            this.findSelectedEncoding()
        }
    }

    findSelectedEncoding() {
        if (this.selectedEncodingId) {
            this.selectedEncoding = this.encodings.find(e => e.EncodingId === this.selectedEncodingId);
        }
    }

    encodingSelectedInternal(e: any): void {
        this.selectedEncoding = e.value as DocumentEncoding;
        if (this.selectedEncodingIdChange) {
            this.selectedEncodingIdChange.emit(this.selectedEncoding?.EncodingId);
        }
    }

    displayExpr = (item?: DocumentEncoding) =>
        this.encodingPickerService.formatEncodingDisplay(item);
}
